import React from "react";
import { WBMFormatMoney } from "wbm-format-money";

const CartTotals = ({ orderTotals }) => {
  let subTotal = orderTotals.subTotal;
  let totalAmountToDisplay =
    orderTotals && orderTotals.totalAmount ? orderTotals.totalAmount : 0;

  return (
    <>
      <div className="row">
        <div className="col-6 text-left-no-padding-left">
          <h3>SUBTOTAL</h3>
        </div>
        <div className="col-6 text-right no-padding-right">
          <div className="subtotal-amount">
            <WBMFormatMoney
              isFancy
              large
              amount={totalAmountToDisplay}
              className="font-weight-bold"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default CartTotals;
